import { useEffect, useState } from "react";
import "./MapEditor.css";
import { MultiSelect } from "react-multi-select-component";
import { nanoid } from "nanoid";
import useAllProjects from "../../../../../../../../../../../hooks/UseAllProjectsLegacy";
import { MODE } from "../../../../../../../../../../types/game";
import {
  RESOURCE_TYPES,
  GameConfig,
  ModifiedGameConfig,
} from "../../../../../../../../../../types/grid";
import Map from "../../../../../../../../../components/Map";

const DEFAULT_WIDTH = 20;
const DEFAULT_HEIGHT = 20;

export const defaultConfig = {
  grid: [[]],
  settings: {
    name: "A",
    rules: {},
    id: "123",
  },
};

// export const defaultConfigs = [
//   {
//     grid: [[]],
//     settings: {
//       name: "A",
//       rules: {},
//       id: "123",
//     },
//   },
//   {
//     grid: [[]],
//     settings: {
//       name: "B",
//       rules: {},
//       id: "123",
//     },
//   },
//   {
//     grid: [[]],
//     settings: {
//       name: "C",
//       rules: {},
//       id: "123",
//     },
//   },
//   {
//     grid: [[]],
//     settings: {
//       name: "D",
//       rules: {},
//       id: "123",
//     },
//   },
//   {
//     grid: [[]],
//     settings: {
//       name: "E",
//       rules: {},
//       id: "123",
//     },
//   },
// ];

const textures = [
  "Floor_1.png",
  "Floor_2.png",
  "Grass_1.png",
  "Grass_2.png",
  "Grass_3.png",
  "Ground_1.png",
  "Ground_2.png",
  "Ground_3.png",
  "Ground_4.png",
  "Ground_5.png",
  "Rock_1.png",
  "Rock_2.png",
  "Roof_1.png",
  "Roof_2.png",
  "Wall_1.png",
  "Wall_2.png",
  "Wall_3.png",
  "Wood_1.png",
  "Wood_2.png",
  "Wood_3.png",
  "Wood_4.png",
  "Wood_5.png",
];

export type Option = {
  label: string;
  value: string | RESOURCE_TYPES;
  disabled?: boolean;
};

const cellProperties: Option[] = [
  {
    label: "Select properties",
    value: "",
    disabled: true,
  },
  {
    label: "Imapassible",
    value: "impassible",
  },
  {
    label: "Ore",
    value: RESOURCE_TYPES.ORE,
  },
  {
    label: "Timber",
    value: RESOURCE_TYPES.TIMBER,
  },
];

type textureType = {
  idx: number;
  src: string;
};

export default function MapEditor() {
  const [config, setConfig] = useState<GameConfig>(defaultConfig);
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const [height, setHeight] = useState(DEFAULT_HEIGHT);
  const [activeTexture, setActiveTexture] = useState<textureType>();
  const [showCellEditor, setShowCellEditor] = useState<boolean>(false);
  const [cellBeingEdited, setCellBeingEdited] = useState({ x: 0, y: 0 });
  const [selectedCellProperties, setSelectedCellProperties] = useState<
    Option[]
  >([cellProperties[0]]);
  const [activeMapIdx, setActiveMapIdx] = useState(
    parseInt(localStorage.getItem("attack-on-grandon-map-idx") || "0")
  );
  const [showMapSelector, setShowMapSelector] = useState(false);
  const [frame, setFrame] = useState(0);

  const { data: allProjects, status, updateProject } = useAllProjects();

  useEffect(() => {
    if (status === "success") {
      const project = allProjects[0] as ModifiedGameConfig;
      let config = {
        settings: project.settings,
        grid: JSON.parse(project.grid),
      };

      if (config && Array.isArray(config.grid)) {
        let arr = [];
        for (var row = 0; row < height; row++) {
          let r = [];
          for (var column = 0; column < width; column++) {
            r.push({
              x: column,
              y: row,
              src: "",
              properties: [],
            });
          }
          arr.push(r);
        }

        setConfig({
          settings: config.settings,
          grid: arr,
        });
        setFrame((cur) => cur + 1);
      }
    }
  }, [width, height, allProjects, status, allProjects]);

  useEffect(() => {
    if (status === "success") {
      const project = allProjects[0] as ModifiedGameConfig;
      let config = {
        settings: project.settings,
        grid: JSON.parse(project.grid),
      };

      if (config) {
        setConfig(config);
      } else {
        setConfig(defaultConfig);
      }

      //   setWidth(configs[activeMapIdx].grid.length);
      //   setHeight(configs[activeMapIdx].grid[0].length);
    }
    // else {
    //   // CREATE DEFAULT EMPTY GRID

    //   let arr = [];
    //   for (var row = 0; row < height; row++) {
    //     let r = [];
    //     for (var column = 0; column < width; column++) {
    //       r.push({
    //         x: column,
    //         y: row,
    //         src: "",
    //         properties: [],
    //       });
    //     }
    //     arr.push(r);
    //   }

    //   setConfig({
    //     settings: defaultConfig.settings,
    //     grid: arr,
    //   });
    //   setFrame((cur) => cur + 1);
    // }
  }, [status, allProjects]);

  const { grid, settings } = config;

  if (status === "loading") {
    return <h1>LOADING</h1>;
  }

  return (
    <div>
      <h1
        style={{
          float: "right",
          right: "210px",
          top: "0px",
          position: "absolute",
        }}
      >
        Map: {config.settings.name}
      </h1>
      <div id="button-container">
        <button
          className="editor-buttons"
          onClick={() => {
            let modifiedGameConfig = {
              grid: JSON.stringify(config.grid),
              settings: config.settings,
            };

            updateProject({
              id: "Jo4KWb3Peg25QGFvaKVLr",
              data: modifiedGameConfig,
            });
          }}
        >
          SAVE
        </button>
        <button
          onClick={() => {
            setShowMapSelector(true);
          }}
          className="editor-buttons"
        >
          CHOOSE MAP
        </button>
        <button onClick={() => {}} className="editor-buttons">
          EXPORT
        </button>
      </div>
      <div id="cell-editor" className={`${showCellEditor && "active"}`}>
        <div className="action-panel-row">
          CELL EDITOR
          <div className="action-panel-row-label">PROPERTIES</div>
          <MultiSelect
            className={"cell-properties"}
            options={cellProperties}
            value={selectedCellProperties}
            onChange={setSelectedCellProperties}
            labelledBy="Select"
          />
        </div>
        <button
          id="save-properties-button"
          onClick={() => {
            const { x, y } = cellBeingEdited;
            setShowCellEditor(false);
          }}
        >
          SAVE
        </button>
      </div>
      <div id="map-selector" className={`${showMapSelector && "active"}`}>
        <div className="action-panel-row">MAPS</div>
        <div className="action-panel-row">
          {/* {configs.map((config, idx) => (
            <div
              key={idx}
              className={`map-selector-map ${idx === activeMapIdx && "active"}`}
              onClick={() => {
                if (idx !== activeMapIdx) {
                  setActiveMapIdx(idx);
                  localStorage.setItem(
                    "attack-on-grandon-map-idx",
                    idx.toString()
                  );
                }
              }}
            >
              {config.settings.name}
            </div>
          ))} */}
        </div>
      </div>
      <div>
        <Map
          mode={MODE.EDITOR}
          grid={config.grid}
          onClick={(y, x) => {
            if (activeTexture) {
              grid[y][x].src = activeTexture.src || "";
              setConfig({ settings, grid });
            }
            setShowCellEditor(false);
            setShowMapSelector(false);
            setSelectedCellProperties([]);
          }}
          onRightClick={(y, x) => {
            setCellBeingEdited({ x, y });
            setShowCellEditor(true);
            setShowMapSelector(false);
            let mappedProps = config.grid[y][x].properties.map((prop) => {
              let p = cellProperties.find((p) => p.value === prop);
              return (
                p || {
                  label: "Select properties",
                  value: "",
                  disabled: true,
                }
              );
            });

            setSelectedCellProperties(mappedProps);
          }}
        />
        <div id="action-panel">
          <div className="action-panel-row">
            <div className="action-panel-row-label">HEIGHT</div>
            <input
              type="number"
              className="action-panel-row-control"
              value={height}
              onChange={(e) => {
                let h = parseInt(e.target.value);
                setHeight(h);
              }}
            />
          </div>
          <div className="action-panel-row">
            <div className="action-panel-row-label">WIDTH</div>
            <input
              type="number"
              className="action-panel-row-control"
              value={width}
              onChange={(e) => {
                let w = parseInt(e.target.value);
                setWidth(w);
              }}
            />
          </div>
          <div className="action-panel-row">
            <div className="action-panel-row-label">TEXTURES</div>
            {textures.map((src, idx) => (
              <div
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/textures/${src})`,
                }}
                key={idx}
                className={`action-panel-texture-cell ${
                  activeTexture?.idx === idx && "active"
                }`}
                onClick={() => {
                  setShowCellEditor(false);
                  setSelectedCellProperties([]);
                  setShowMapSelector(false);

                  setActiveTexture({
                    idx,
                    src,
                  });
                }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
